import { Injectable } from '@angular/core';
import { CookieAdapterService } from '../core/cookie-adapter.service';

const TOKEN_COOKIE_KEY = 'OESSOTOK';
const TOKEN_SEPARATOR = '.';
const THIRD_PARTY_TOKEN_TYPE_KEY = 'THIRD_PARTY_TOKEN_TYPE';
const TEMP_TOKEN_COOKIE_KEY = 'OESSOTEMPTOK';
const REFRESH_TOKEN_COOKIE_KEY = 'OESSOREFRESHTOK';

enum ThirdPartyTokenTypes {
  OE_SFDC = 'OE_SFDC',
}
enum TokenAnatomy {
  HEADER,
  DATA,
  SIGNATURE,
}

@Injectable()
export class TokenService {
  constructor(private readonly cookieService: CookieAdapterService) {}

  public get decodedToken() {
    return this.token.split(TOKEN_SEPARATOR).map((fragment, index) => {
      if (index === TokenAnatomy.SIGNATURE) {
        return fragment;
      }
      return JSON.parse(atob(fragment));
    });
  }

  public get decodedTempToken() {
    if (!this.tempToken) {
      return null;
    }

    return this.tempToken.split(TOKEN_SEPARATOR).map((fragment, index) => {
      if (index === TokenAnatomy.SIGNATURE) {
        return fragment;
      }
      return JSON.parse(atob(fragment));
    });
  }

  public get token() {
    return this.cookieService.get(TOKEN_COOKIE_KEY);
  }

  public get tempToken() {
    return this.cookieService.get(TEMP_TOKEN_COOKIE_KEY);
  }

  public get refreshToken() {
    return this.cookieService.get(REFRESH_TOKEN_COOKIE_KEY);
  }

  public get isTempTokenExpired() {
    if (!this.decodedTempToken) {
      return false;
    }
    const expirationDate = this.decodedTempToken[TokenAnatomy.DATA].exp * 1000;
    const now = Date.now();
    return expirationDate < now;
  }

  public getPersonIdFromTempToken() {
    return this.decodedTempToken[TokenAnatomy.DATA].PERSON_ID;
  }

  public removeTempToken() {
    this.cookieService.remove(TEMP_TOKEN_COOKIE_KEY);
  }

  public get hasToken() {
    return !!this.token;
  }

  public get tokenHeader() {
    return this.decodedToken[TokenAnatomy.HEADER];
  }

  public get tokenData() {
    return this.decodedToken[TokenAnatomy.DATA];
  }

  public get tokenSignature() {
    return this.decodedToken[TokenAnatomy.SIGNATURE];
  }

  public get isLoggedAs() {
    return this.tokenData[THIRD_PARTY_TOKEN_TYPE_KEY] === ThirdPartyTokenTypes.OE_SFDC;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/token.service.ts